/**
 * The staff entries in the sidebar's Admin section. Support Desk is shown only
 * while the desk is switched on (the backend status probe succeeds); a
 * switched-off feature is absent, never a dead link.
 */
export interface StaffNavItem {
  path: string;
  label: string;
}

export function staffNavItems(flags: { isAdmin: boolean; supportDeskOn: boolean }): StaffNavItem[] {
  if (!flags.isAdmin) return [];
  const items: StaffNavItem[] = [{ path: '/admin', label: 'Analytics' }];
  if (flags.supportDeskOn) items.push({ path: '/admin/support', label: 'Support Desk' });
  return items;
}
